import { REFERENCE_TYPE_SERVICE_NAME, ReferenceTypeServiceProvider } from './reference-type.service'

export const REFERENCE_TYPE_SERVICES_MODULE_NAME = 'simax.services.reference-type'

const referenceTypeServicesModule = angular.module(REFERENCE_TYPE_SERVICES_MODULE_NAME, [])

referenceTypeServicesModule.provider(REFERENCE_TYPE_SERVICE_NAME, ReferenceTypeServiceProvider)
